import { RouterProvider } from "react-router-dom";
import React from "react";
import { ReactQueryProvider } from "services/reactQuery";
import { router } from "router";
import "./styles/index.scss";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";

import { root } from "utils/nodes";

const excludeList = [
  "Warning: You provided a `checked` prop",
  "Warning: You provided a `value` prop",
];
// const excludeList = [];
const initialConsoleError = console.error;
console.error = (...args) => {
  if (args?.length) {
    for (const arg of args) {
      for (const excludeItem of excludeList) {
        if (typeof arg === "string" && arg.startsWith(excludeItem)) return;
      }
    }
  }
  initialConsoleError(...args);
};

root.render(
  <ReactQueryProvider>
    <RouterProvider router={router} />
  </ReactQueryProvider>
);
